import { lazy } from 'react'
import { TrendingUp, Sprout, Handshake } from 'lucide-react'
import type { FeatureRoute, NavItem } from '@/features/types'

const Pipeline = lazy(() => import('@/features/deals/pages/Pipeline').then((m) => ({ default: m.Pipeline })))
const Prospects = lazy(() => import('@/features/deals/pages/Prospects').then((m) => ({ default: m.Prospects })))
const ProspectDetail = lazy(() => import('@/features/deals/pages/ProspectDetail').then((m) => ({ default: m.ProspectDetail })))
const ActiveNegotiations = lazy(() => import('@/features/deals/pages/ActiveNegotiations').then((m) => ({ default: m.ActiveNegotiations })))
const NegotiationDetail = lazy(() => import('@/features/deals/pages/NegotiationDetail').then((m) => ({ default: m.NegotiationDetail })))
const DealDetail = lazy(() => import('@/features/deals/pages/DealDetail').then((m) => ({ default: m.DealDetail })))
const DealNew = lazy(() => import('@/features/deals/pages/DealNew').then((m) => ({ default: m.DealNew })))

export const dealsRoutes: FeatureRoute[] = [
  { path: 'pipeline', element: <Pipeline /> },
  { path: 'pipeline/views/:viewId', element: <Pipeline /> },
  // Deals at their own URLs (#GzG1LcpY). No nav entry — deals are reached from
  // the pipeline, the same way an RFP is reached from the tracker.
  //
  // These are no longer additive: the pipeline now navigates HERE. Cards, table
  // rows and roadmap bars open /deals/:id, and "+ Add employer" opens
  // /deals/new?stage=. The DealPanel drawer this replaced has been deleted.
  //
  // /pipeline?dealId=X is kept working as a REDIRECT, because ten link sites plus
  // bookmarks and already-sent emails use it. Only a well-formed uuid redirects —
  // an unvalidated id reaches `WHERE id = :id::uuid` and 500s, exactly the hazard
  // described below for /deals/new.
  //
  // 'deals/new' is declared BEFORE 'deals/:id' deliberately. React Router ranks
  // static segments above dynamic ones so this should not matter, but getting it
  // wrong is expensive rather than cosmetic: /deals/new would match :id, the
  // page would GET /deals/new, and the backend's `WHERE id = :id::uuid` cast
  // throws — a 500, not a 404.
  { path: 'deals/new', element: <DealNew /> },
  { path: 'deals/:id', element: <DealDetail /> },
  { path: 'prospects', element: <Prospects /> },
  { path: 'prospects/:id', element: <ProspectDetail /> },
  { path: 'negotiations', element: <ActiveNegotiations /> },
  { path: 'negotiations/:id', element: <NegotiationDetail /> },
]

// Nav order mirrors the funnel agreed in the bi-weekly sync: Prospects convert
// (directly, or via a won RFP) into Active Negotiations — so the tab sits
// between Prospects and RFP tracker (rfpNav spreads right after dealsNav).
export const dealsNav: NavItem[] = [
  { to: '/pipeline', label: 'Pipeline', icon: TrendingUp, section: 'Sales' },
  { to: '/prospects', label: 'Prospects', icon: Sprout, section: 'Sales' },
  { to: '/negotiations', label: 'Active negotiations', icon: Handshake, section: 'Sales' },
]
